module.exports = __webpack_public_path__ + "img/pl.7d6f7a5a.png";